(() => {
  const grid = document.querySelector('#ce-catalog-grid');
  if (!grid) return;

  const buttons = document.querySelectorAll('[data-ce-filter]');
  const cards = grid.querySelectorAll('[data-ce-category]');

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const filter = button.dataset.ceFilter;
      buttons.forEach((item) => {
        const selected = item === button;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-pressed', String(selected));
      });

      cards.forEach((card) => {
        card.hidden = filter !== 'all' && card.dataset.ceCategory !== filter;
      });
    });
  });
})();
